import React from 'react';
import PropTypes from 'prop-types';

import './payment-result-v2.scss';

const ArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" style={{ fill: 'none' }} />
  </svg>
);

const PaymentResultV2 = ({ tone, image, title, accent, text, primary, secondary }) => (
  <section className={`prv2 prv2--${tone} container`}>
    <img className="prv2__art" src={image} alt="" width="720" height="423" decoding="async" />

    <h1 className="prv2__title">
      {title}
      {accent && <span className="prv2__accent">{accent}</span>}
    </h1>

    <p className="prv2__text">{text}</p>

    <div className="prv2__actions">
      <button type="button" className={`v2-btn ${tone === 'success' ? 'v2-btn--green' : 'v2-btn--violet'}`} onClick={primary.onClick}>
        {primary.label}
        <ArrowRight />
      </button>
      {secondary && (
        <button type="button" className="v2-btn v2-btn--outline" onClick={secondary.onClick}>
          {secondary.label}
        </button>
      )}
    </div>
  </section>
);

const actionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
});

PaymentResultV2.propTypes = {
  tone: PropTypes.oneOf(['success', 'failed']).isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  accent: PropTypes.string,
  text: PropTypes.string.isRequired,
  primary: actionShape.isRequired,
  secondary: actionShape,
};

PaymentResultV2.defaultProps = {
  accent: '',
  secondary: null,
};

export default PaymentResultV2;
